import axios from "axios";
import { getHeaders, checkStatus } from "../../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";

const baseURL = process.env.REACT_APP_BASE_URL;
 

  export async function getEmployeeAwards(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/Awards`,params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }
    
  }


export async function addEmployeeAwards(params) {  
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/Awards/Add`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  }catch(error){
    return Promise.reject(error);
  }
  
}

   //Delete method when request send in body only.
  export async function deleteEmployeeAwards(params) { 
    try {
      const response = await axiosInstance.delete(`${baseURL}/Employee/Awards/Delete`, {
        headers: await getHeaders(),
        data: params,
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  export async function EmployeeAwardsYears(params) {
    try {
      const response = await axiosInstance.get(`${baseURL}/Employee/Awards/Years?OrgId=${params.OrgId}`, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }
    
  }

  export async function EmployeeAwardsGet(params) {
    try {
      const response = await axiosInstance.get(`${baseURL}/Org/OrgAwards/Get?OrgId=${params.OrgId}`, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }
    
  }